import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FILE_LIMIT_SIZE_MB } from '../../select-files.constants';

@Component({
  selector: 'ui-file-item',
  styleUrls: ['./file-item.component.scss'],
  templateUrl: './file-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIFileItemComponent {
  readonly file = input.required<File>();
  readonly tooLarge = input<boolean>(false);
  readonly clickEvent = output<void>();

  readonly MAX_FILE_SIZE_MB: number = FILE_LIMIT_SIZE_MB;

  click(): void {
    this.clickEvent.emit();
  }
}
